import { client } from "api";
import { AbsentUser } from "features/auth/types/user";

export type GetTodaysAbsenteesResponse = AbsentUser[];

export const getTodaysAbsentees = (): Promise<GetTodaysAbsenteesResponse> =>
  client.get<GetTodaysAbsenteesResponse>(`/statistics/todays-absentees`).then((res) => res.data);
